import React from 'react';
import { useChatContext } from 'stream-chat-react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import { Box, IconButton, Typography } from '@mui/material';

import RBAC from '@common/components/RBAC';
import { useToggle } from '@common/helpers/useToggle';

import SendScheduledMessageModal from '../SendScheduledMessageModal';
import UpdateChannelModal from '../UpdateChannelModal';
import useChatTitle from '../utils/useChatTitle';
import ChannelListHeaderDescription from './Description';
import ChatLastActivity from './LastActivity';
import ChannelListHeaderWorkTimeInfo from './WorkTimeInfo';
import * as Styled from './styled';

function ChannelListHeader() {
	const chatName = useChatTitle();
	const { channel } = useChatContext();

	const updateChannelModal = useToggle();
	const sendScheduledMessageModal = useToggle();

	return (
		<>
			<Styled.Wrap>
				<Styled.Info>
					<Styled.TitleWrap>
						<Typography variant="subtitle1">{chatName}</Typography>
						<RBAC granted={['Teacher', 'Mentor/Tutor', 'Curator']}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<IconButton onClick={() => sendScheduledMessageModal.onOpen()}>
									<ScheduleSendIcon />
								</IconButton>
								<IconButton onClick={() => updateChannelModal.onOpen()}>
									<EditOutlinedIcon />
								</IconButton>
							</Box>
						</RBAC>
					</Styled.TitleWrap>
					<RBAC grantedOnly granted={['Mentor/Tutor', 'Teacher', 'Curator']}>
						<ChatLastActivity />
					</RBAC>
					<ChannelListHeaderWorkTimeInfo />
				</Styled.Info>
				<ChannelListHeaderDescription />
			</Styled.Wrap>

			{sendScheduledMessageModal.isOpen && (
				<SendScheduledMessageModal channel={channel} onClose={sendScheduledMessageModal.onClose} />
			)}

			{updateChannelModal.isOpen && (
				<UpdateChannelModal
					channel={channel}
					chatName={chatName}
					onClose={updateChannelModal.onClose}
				/>
			)}
		</>
	);
}

export default ChannelListHeader;
